var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCustomerService = function SvgCustomerService(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "M19.364 12.905v-1.118C19.364 6.998 16.067 4 12 4s-7.364 2.998-7.364 7.787v1.118m13.091 4.857v-4.857h.818c1.356 0 2.455 1.087 2.455 2.428 0 1.342-1.099 2.429-2.455 2.429zM6.273 12.905v4.857h-.818C4.099 17.762 3 16.675 3 15.333c0-1.34 1.099-2.428 2.455-2.428zM14.455 21c2.485 0 4.5-1.45 4.5-3.238",
    vectorEffect: "non-scaling-stroke"
  })));
};
export { SvgCustomerService as ReactComponent };
export default __webpack_public_path__ + "38797ac7953a4c1fccd368ec98f0ce45.svg";